import { Guide } from '../components/Guide'
import { guides } from '../content/guides'

export const GettingStartedPage = () => <Guide content={guides.start} />
